import { render, staticRenderFns } from "./DoctorTable.vue?vue&type=template&id=121edd60&scoped=true"
import script from "./DoctorTable.vue?vue&type=script&lang=js"
export * from "./DoctorTable.vue?vue&type=script&lang=js"
import style0 from "./DoctorTable.vue?vue&type=style&index=0&id=121edd60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121edd60",
  null
  
)

export default component.exports